import { Box, Text, useBreakpointValue } from "@chakra-ui/react";

import LogoFooter from "@/assets/LogoFooter";
import { FOOTER_TEXT, PRIVACY_POLICY_URL } from "@/common/constants";
import styles from './styles/Footer.module.css';

const Footer = () => {
    const fontSize = useBreakpointValue({ base: 'sm', md: 'md' });

    return (
        <Box as="footer" className={styles.footer}>
            <Text className={styles.footerText} fontSize={fontSize}>
                {FOOTER_TEXT}
                <a href={PRIVACY_POLICY_URL} target="_blank" className={styles.privacyPolicy}>
                    Privacy Policy
                </a>.
            </Text>
            <LogoFooter />
        </Box>
    );
}

export default Footer;
